export default __webpack_public_path__ + "src/assets/taboola_logo.png";